import { Trash } from 'react-feather'
import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
    padding: 1rem 0.6rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
`

export const ContainerQuantity = styled.div`
    display: flex;
    gap: 0.7rem;
    align-items: center;
    margin-bottom: .5rem;
`

export const CustomButton = styled(ButtonMui)`
    width: 7rem !important;    
    height: 2.2rem !important;
    margin: 0 !important;
`

export const CustomButtonDamageFinish = styled(ButtonMui)`
    width: 9rem !important;    
    height: 2.2rem !important;
    margin: 0 !important;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 10.6rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomTextFieldDamage = styled(TextFieldMui)`
    margin: 0 !important;
    width: 10.6rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomTextFieldDamageValidate = styled(TextFieldMui)`
    margin: 0 !important;
    width: 7rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomTextFieldExpirationDate = styled(TextFieldMui)`
    margin: 0 !important;
    width: 7.5rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomTextFieldQuantity = styled(TextFieldMui)`
    margin: 0 !important;
    width: 5.2rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const CustomTextFieldQuantityValidate = styled(TextFieldMui)`
    margin: 0 !important;
    width: 6.8rem !important;
    height: 3rem !important;

    & input {
        height: 1rem !important;
    }
`

export const ContainerButton = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
`

export const ContainerButtonDamage = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1.2rem;
`

export const ContainerButtonDamageValidate = styled.div`
    display: flex;
    gap: 1rem;
    margin-top: 1.2rem;
`

export const ContainerButtonZeroBottom = styled.div`
    display: flex;
    gap: 1rem;
    position: relative;
    margin-bottom: 1rem;
    @media (max-width: 768px) {
        bottom: 0;
        position: absolute;
    }
`

export const ContainerList = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #000;
    width: 22rem;
    height: 10rem;
    max-height: 10rem;
    overflow-y: auto;
`

export const ContainerItem = styled.div`
    display: flex;
    gap: 0.6rem;
    padding: 0.3rem;
`

export const ContainerDamage = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.6rem;
`

export const ContainerTextField = styled.div`
    display: flex;
    gap: 0.6rem;
`

export const RemoveBatchButton = styled(Trash)`
    cursor: pointer;
    color: red;
`

export const ContainerPosition = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: -0.9rem;
    p{
        display: flex;
        letter-spacing: 0.3px;
        text-align: center;
        gap: 0.6rem;
    }
`

export const CustomButtonReset = styled(ButtonMui)`
    width: 11rem !important;
    height: 1.6rem !important;
    margin: 0 !important;
`

export const ContainerTotal = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 0.9rem;
`

export const CustomButtonAddValidate = styled(ButtonMui)`
    width: 5.5rem !important;
    height: 3rem !important;
    margin: 0 !important;
`

export const CustomButtonAddSimple = styled(ButtonMui)`
    width: 5.5rem !important;
    height: 3rem !important;
    margin: 0 !important;
`
